import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BuscarBitacora } from '../interfaces/beans.interface';

@Injectable({
    providedIn: 'root'
})
export class VistaService {

  url = environment.url + '/vistaAcciones';

  constructor(private http: HttpClient) {}

  get() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/menusPermisos?cliente=${ localStorage.getItem('idCliente') }&mdc=${ localStorage.getItem('idMdc') }&usuario=${ localStorage.getItem('idUsuario') }&tipo=3489`, { headers }).pipe( map( data => data));
  }

}